/*
 * @Date: 2020-06-30 18:20:18
 * @LastEditTime: 2021-11-29 16:19:19
 */
import { PunchServer } from './Modules/punchServer'
import { IndexServer } from './Modules/indexServer'
import { FreeLectureServer } from './Modules/freeLectureServer'
import { CommonServer } from './Modules/commonServer'
import { CategoryServer } from './Modules/categoryServer'
import { SearchServer } from './Modules/searchServer'
import { reportServer } from './Modules/reportServer'
import { QiankunServer } from './Modules/qiankunServer'

export const HttpServer = {
  ...PunchServer,
  ...IndexServer,
  ...FreeLectureServer,
  ...CommonServer,
  ...CategoryServer,
  ...SearchServer,
  ...reportServer,
  QiankunServer
}

export default HttpServer



// WEBPACK FOOTER //
// ./src/services/server.ts